import axiosInstance from "../axios_instance";

export async function createMyCalendarReminder(body) {
  try {
    return await axiosInstance.post(`myCalendar/`, body);
  } catch (error) {
    return error;
  }
}

export async function updateMyCalendarReminder(body, id) {
  try {
    return await axiosInstance.put(`myCalendar/${id}`, body);
  } catch (error) {
    return error;
  }
}

export async function deleteMyCalendarReminder(userID, reminderID) {
  try {
    return await axiosInstance.delete(`myCalendar/${userID}/${reminderID}`);
  } catch (error) {
    return error;
  }
}

export async function getAllMyCalendarReminders(body) {
  try {
    return await axiosInstance.post(`myCalendar/get`, body);
  } catch (error) {
    return error;
  }
}
